import clsxm from '@/lib/clsxm';
import { track } from '@/lib/tracking';
import {
  LinkGroup,
  TrackingEventCategory,
  TrackingEventName,
  TrackingModule,
} from '@/lib/types';
import { useGlobalContext } from '@/hooks/use-global-context';
import useMonitorVisibility from '@/hooks/use-monitor-visibility';

import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

const background = {
  DEFAULT: 'bg-gray-50',
  TRANSPARENT_BACKGROUND: 'bg-transparent',
};

export default function LinkGroupRenderer(props: LinkGroup) {
  const { pageMeta } = useGlobalContext();
  const [ref] = useMonitorVisibility({
    triggerOnce: () => {
      track({
        pageMeta,
        name: TrackingEventName.ModuleViewed,
        category: TrackingEventCategory.ModuleViewed,
        module: TrackingModule.RelatedContent,
        properties: {
          position_number: props.index,
        },
      });
    },
  });

  const listBg = props.variant__LinkGroup
    ? background[props.variant__LinkGroup]
    : background.DEFAULT;

  return (
    <div
      ref={ref}
      data-testid='related-content'
      className={clsxm('w-full rounded-lg p-4 sm:p-6', listBg)}
    >
      <Typography.Heading4>{props.title}</Typography.Heading4>
      <ul className='mt-4 columns-1'>
        {props.links.map(({ label, href }, index) => (
          <li key={index} className='list-none'>
            <Link href={href || '#'} variant={LinkVariant.LINK}>
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
